export default {
  sections: [
  {
    "id": "business",
    "title": "Details of Registered Business",
    "repeatable": false,
    "fields": [
      {
        "id": "businessName",
        "type": "text",
        "label": "Business Name",
        "required": true
      },
      {
        "id": "businessAddress",
        "type": "textarea",
        "label": "Business Address",
        "required": true
      },
      {
        "id": "businessTel",
        "type": "tel",
        "label": "Business Tel. No",
        "required": true
      }
    ]
  },
  {
    "id": "jobAddress",
    "title": "Job Address",
    "repeatable": false,
    "fields": [
      {
        "id": "jobName",
        "type": "text",
        "label": "Name",
        "required": true
      },
      {
        "id": "jobAddress",
        "type": "textarea",
        "label": "Address",
        "required": true
      },
      {
        "id": "jobTel",
        "type": "tel",
        "label": "Tel. No",
        "required": true
      }
    ]
  },
  {
    "id": "landlordAgent",
    "title": "Landlord/Agent Address",
    "repeatable": false,
    "fields": [
      {
        "id": "landlordName",
        "type": "text",
        "label": "Name"
      },
      {
        "id": "landlordAddress",
        "type": "textarea",
        "label": "Address"
      },
      {
        "id": "landlordTel",
        "type": "tel",
        "label": "Tel. No"
      }
    ]
  },
  {
    "id": "vesselDetails",
    "title": "Details of Hot Water Storage Vessel",
    "repeatable": false,
    "fields": [
      {
        "id": "make",
        "type": "text",
        "label": "Make",
        "required": true
      },
      {
        "id": "model",
        "type": "text",
        "label": "Model",
        "required": true
      },
      {
        "id": "location",
        "type": "text",
        "label": "Location",
        "required": true
      },
      {
        "id": "makersWarningLabel",
        "type": "select",
        "label": "Is a Makers warning label attached?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "scaleReducerFitted",
        "type": "select",
        "label": "Has a scale reducer been fitted?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "capacity",
        "type": "number",
        "label": "Capacity (Ltrs)",
        "required": true
      }
    ]
  },
  {
    "id": "heatSource",
    "title": "Heat Source",
    "repeatable": false,
    "fields": [
      {
        "id": "heatSourceType",
        "type": "select",
        "label": "Direct or Indirect?",
        "required": true,
        "options": [
          "Direct",
          "Indirect"
        ]
      },
      {
        "id": "gasBoilerType",
        "type": "select",
        "label": "Gas Boiler and/or Solar or Immersion Heaters",
        "required": true,
        "options": [
          "Gas Boiler",
          "Solar",
          "Immersion Heaters",
          "Gas Boiler + Solar",
          "Gas Boiler + Immersion",
          "Solar + Immersion",
          "All Three"
        ]
      }
    ]
  },
  {
    "id": "installing",
    "title": "Installing",
    "repeatable": false,
    "fields": [
      {
        "id": "inletWaterPressureFlowRate",
        "type": "text",
        "label": "Inlet water pressure & flow rate",
        "required": true
      }
    ]
  },
  {
    "id": "commissioning",
    "title": "Commissioning",
    "repeatable": false,
    "fields": [
      {
        "id": "fullyCommissioned",
        "type": "select",
        "label": "Fully commissioned?",
        "required": true,
        "options": [
          "Yes",
          "No",
          "N/A"
        ]
      }
    ]
  },
  {
    "id": "operatingDetails1",
    "title": "Operating Details of Hot Water Storage Vessel",
    "repeatable": false,
    "fields": [
      {
        "id": "systemOperatingPressure",
        "type": "number",
        "label": "System operating pressure (Bar)",
        "required": true
      },
      {
        "id": "operatingPressureExpansionVessel",
        "type": "number",
        "label": "Operating pressure of expansion vessel (Bar)",
        "required": true
      },
      {
        "id": "operatingPressureExpansionValve",
        "type": "number",
        "label": "Operating pressure of expansion valve (Bar)",
        "required": true
      },
      {
        "id": "operatingTempReliefValve",
        "type": "number",
        "label": "Operating temperature of temperature relief valve or Operating temperature and pressure of combined temperature and pressure relief valve (°C or °C/Bar)",
        "required": true
      },
      {
        "id": "maxPrimaryCircuitPressureFlow",
        "type": "text",
        "label": "Maximum primary circuit pressure and flow temperature (indirectly heated vessel) (Bar/°C)",
        "required": true
      }
    ]
  },
  {
    "id": "operatingDetails2",
    "title": "Operating Details of Hot Water Storage Vessel",
    "repeatable": false,
    "fields": [
      {
        "id": "nominalSizeD1",
        "type": "number",
        "label": "Nominal size of D1 (mm)",
        "required": true
      },
      {
        "id": "lengthD1",
        "type": "number",
        "label": "Length of D1 (mm)",
        "required": true
      },
      {
        "id": "numberOfDischarges",
        "type": "number",
        "label": "Number of discharges",
        "required": true
      },
      {
        "id": "sizeOfManifold",
        "type": "text",
        "label": "Size of manifold, if more than 1 discharge"
      },
      {
        "id": "tundishSameLocation",
        "type": "select",
        "label": "Is tundish installed within the same location as the hot water storage vessel?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "tundishVisible",
        "type": "select",
        "label": "Is the tundish visible?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "automaticMeansIdentifying",
        "type": "select",
        "label": "Are automatic means of identifying discharge installed?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      }
    ]
  },
  {
    "id": "dischargePipework",
    "title": "Discharge Pipework (D2) – tundish to point of termination",
    "repeatable": false,
    "fields": [
      {
        "id": "nominalSizeD2",
        "type": "number",
        "label": "Nominal size of D2 (mm)",
        "required": true
      },
      {
        "id": "pipeworkMaterial",
        "type": "text",
        "label": "Pipework material",
        "required": true
      },
      {
        "id": "pipeworkMinVerticalLength",
        "type": "select",
        "label": "Does pipework have a minimum vertical length of 300mm from tundish?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "pipeworkFallContinuously",
        "type": "select",
        "label": "Does the pipework fall continuously to point of termination?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "methodOfTermination",
        "type": "text",
        "label": "Method of termination? (gully, low level, soil stack or high level)",
        "required": true
      },
      {
        "id": "terminationSatisfactory",
        "type": "select",
        "label": "Is the method of termination satisfactory?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      }
    ]
  },
  {
    "id": "defects",
    "title": "Defect(s) Identified",
    "repeatable": false,
    "fields": [
      {
        "id": "defectsIdentified",
        "type": "textarea",
        "label": "Defect(s) Identified"
      }
    ]
  },
  {
    "id": "workCarriedOut",
    "title": "Work Carried Out",
    "repeatable": false,
    "fields": [
      {
        "id": "workCarriedOut",
        "type": "textarea",
        "label": "Work Carried Out",
        "required": true
      }
    ]
  },
  {
    "id": "receivedBy",
    "title": "Received By",
    "repeatable": false,
    "fields": [
      {
        "id": "receivedByName",
        "type": "text",
        "label": "Print Name",
        "required": true
      },
      {
        "id": "receivedByDate",
        "type": "date",
        "label": "Date",
        "required": true
      }
    ]
  },
  {
    "id": "issuedBy",
    "title": "Issued By",
    "repeatable": false,
    "fields": [
      {
        "id": "engineerSignature",
        "type": "signature",
        "label": "Signature",
        "required": true
      },
      {
        "id": "issuedByDate",
        "type": "date",
        "label": "Date",
        "required": true
      }
    ]
  }
]
};
